import { DownloadUrlLink } from "~/common/components/Link";
import { trackPDPDownloadBasicFrequencies } from "~/app/analytics/ga/ga";
import { type PdpPageProductData } from "~/features/productDetails/models/PdpPageProductData";
import { useTranslation } from "react-i18next";
import { getBearingXURL } from "~/utils/url/urlUtils";

interface BearingXPdfDownloadLinkProps {
  product: Pick<PdpPageProductData, "designation">;
  bearingXId: string;
}

const BearingXPdfDownloadLink = ({ product, bearingXId }: BearingXPdfDownloadLinkProps) => {
  const { t } = useTranslation();

  const label = t("productDetailPage.downloadPdfBasicFrequencies");

  return (
    <DownloadUrlLink
      href={getBearingXURL(bearingXId)}
      className={"scha__pdp__pdf-link"}
      onClick={() => trackPDPDownloadBasicFrequencies(product.designation)}
    >
      {label}
    </DownloadUrlLink>
  );
};

export default BearingXPdfDownloadLink;
